// extracted by mini-css-extract-plugin
export default {"container":"BaseLink_container_D3tyF","inner":"BaseLink_inner_efRMz"};